import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { observableOf } from '@app/shared/rx';
import { ButtonDefinition } from '@app/shared/types';
import { isFunction } from 'lodash';
import { isObservable, Observable } from 'rxjs';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xea-buttons',
  templateUrl: './buttons.component.html',
  styleUrls: ['./buttons.component.scss'],
  standalone: false,
})
export class ButtonsComponent {
  @Input() public buttons: ButtonDefinition[] = [];

  public selectButton(button: ButtonDefinition) {
    if (isFunction(button?.click)) {
      button.click();
    }
  }

  public getButtonDynamicProperty(
    btn: ButtonDefinition,
    path: 'hidden' | 'disabled',
  ): Observable<boolean> {
    const property = btn?.[path];

    if (isFunction(property)) {
      return observableOf(property());
    }

    if (isObservable(property)) {
      return property as Observable<boolean>;
    }

    return observableOf(property as boolean);
  }
}
